// window.jQuery = window.$ = require('jquery');
import { TweenMax } from 'gsap';
import {ua} from './_module/ua';
import {state} from './_module/state';
import {wheel} from './_module/wheel';
import {whalehandle} from './_module/whalehandle';
import {inview} from './_module/inviewhandle';
import {modal} from './_module/modal';
import {menu} from './_module/menu';
import {windowSize} from './_module/windowSize';
import {nomalScroll} from './_module/nomalscroll';
import slick from 'slick-carousel';
import "./../style/app.scss";

class Whale {

  constructor() {
    this.body=$("body");
    this.window=$(window);
    this.document=$(document);
    this.slickContent02=$('.m-slick02 ul');
    this.contentRoot=document.getElementById("wrap");
    this.opening=$('.mv-inner');
    this.load=$('#l-loading');
    this.isMOBILE="MOBILE";
    this.isIE_EDGE="IE_EDGE";
    this.isPC="PC";
    this.currentWindowWidth=windowSize.clientSize().W;
    this.slickConfig={
      dots : false,
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      autoplay: false,
      speed: 650,
      centerMode: true,
      centerPadding: '28%',
      cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
      draggable: true,
      // pauseOnHover: false,
      // focusOnSelect: true,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            // slidesToShow: 1,
            centerPadding: '0px',
          }
        }
      ]
    }

    this.loading();
  }

  init() {

    this.body.addClass(ua());
    this.resize();
    this.slickInit();
    this.opening.addClass('is-active');

    if(ua() == this.isPC){
      if(windowSize.device()==false){
        modal.onClickNoScroll();
        menu.onClickNoScroll();
        menu.sceneAnchorNoScroll();
        whalehandle.onClickNoScroll();
        // whalehandle.onClickPager();
        this.mvMobile();
        nomalScroll.init();
        // this.whaleFirst();
      }
      else{
        wheel.mouseWheelEvt();
        whalehandle.onClick();
        whalehandle.onClickPager();
        modal.onClick();
        menu.onClick();
        menu.sceneAnchor();
      }
    }
    else if (ua() == this.isMOBILE){
      modal.onClickNoScroll();
      menu.onClickNoScroll();
      menu.sceneAnchorNoScroll();
      whalehandle.onClickNoScroll();
      menu.sceneAnchorNoScroll();
      this.mvMobile();
      nomalScroll.init();
    }
    else if (ua() == this.isIE_EDGE){
      modal.onClickNoScroll();
      menu.onClickNoScroll();
      menu.sceneAnchorNoScroll();
      whalehandle.onClickNoScroll();
      whalehandle.onClickPager();
      menu.sceneAnchorNoScroll();
      this.whaleFirst();
    }

    // 2022-09-05 Loading後のアンカーリンク追加(1/2)
    this.chechAnchorHash();

  }

  // 2022-09-05 Loading後のアンカーリンク追加(2/2)
  chechAnchorHash(){
    const offsetScene = 2;
    let hash = location.hash.replace('#','');
    let $sections = $('.content.c-scene > section');
    let targetScene = null;
    let targetName = null;
    let isHashLink = false;
    $sections.each(function(i){
      targetName = $(this).attr('id');
      if(targetName === hash){
        targetScene = i;
        isHashLink = true;
      }
    });
    if(isHashLink) {
      // PC or MOBILEで処理を分ける
      if(ua() == this.isPC){
        targetScene = targetScene + offsetScene;
        wheel.onClickToNextScene(targetScene);
      }
      if(ua() == this.isMOBILE){
        const speed = 800;
        let targetOffset = $("#" + hash).offset().top;
        window.scrollTo(0,0);
        $('html,body').stop().animate({scrollTop: targetOffset},speed,'swing');
      }
    }

  }

  slickInit(){
    this.slickContent02.slick(this.slickConfig)
    .on(
      'beforeChange',
      function(event, slick, currentSlide, nextSlide) {
      }
    )
    .on(
      'afterChange',
      function(event, slick, currentSlide) {
      }
    );
  }

  resize() {
    let setTimeoutId=null;
    window.addEventListener(
      'resize',
      (e) => {
        if (setTimeoutId) clearTimeout(setTimeoutId);
        setTimeoutId=setTimeout(
          () => {
            this.device();
            wheel.resetSceneSize();
            if (state.currentID==2){
              inview.stackItemsPosition();
            }
            setTimeoutId=null;
          }, 1000
        );
      }
    );
  }

  device(){
    if(!windowSize.device()){
      this.currentWindowWidth
      if(this.currentWindowWidth != windowSize.clientSize().W){
        location.reload(false);
        this.currentWindowWidth=windowSize.clientSize().W;
      }
    }
  }

  whaleFirst(){
    $(".w-whale01").addClass("is-active");
  }

  mvMobile(){
    TweenMax.set($('.mv'),{"height": windowSize.clientSize().H});
  }

  pageStart(){
    TweenMax.to(
      this.load,
      1,
      {
        delay:2.5,
        autoAlpha: 0,
        onComplete:()=>{
          this.init();
        }
      }
    );
  }

  loading(){
    this.pageStart();
  }

}

document.addEventListener('DOMContentLoaded', () => {
  new Whale()
})
// window.onpageshow=function(event) {
//   if(event.persisted) window.location.reload();
// };
// window.addEventListener("DOMContentLoaded", () => {
//   new Whale()
// });